<template>
  <a-layout class="download">
    <a-layout-header>
      <PageNav></PageNav>
    </a-layout-header>
    <a-layout-content>
      <div class="content-main flex jus-center">
        <div class="block_box">
          <div class="top_left flex flex-column align-start">
            <p class="font-32 font-bold color-white">{{ $t('app_download.title') }}</p>
            <p class="font-22 font-bold color-white">{{ $t('app_download.subtitle') }}</p>
            <div class="flex align-center download-mode">
              <div class="flex flex-column">
                <!-- 仅保留iOS下载 -->
                <div class="btn flex align-center jus-center" @click="downloadIOS" style="cursor: pointer;">
                  <img src="@/assets/ios.png">
                  <span class="font-14 font-bold color-white">{{ iosDownloadText }}</span>
                </div>
              </div>
              <div class="flex flex-column align-center jus-center qrcode_wrap">
                <div class="qrcode flex align-center jus-center">
                  <img :src="config['dpage'] || '@/assets/qrcode.png'">
                </div>
                <span>{{ $t('app_download.scan_qr_code') }}</span>
              </div>
            </div>
          </div>
          <div class="pro-group">
            <div class="pro-item" v-for="(proItem, index) in proGroup" :key="index" @mouseenter="mouseEnter(index)"
                 :class="{ active: index == isActive }">
              <span>{{ proItem.title }}</span>
              <p>{{ proItem.context }}</p>
              <img :src="proItem.imgSrc" alt="">
            </div>
          </div>
          
          <!-- iOS 用户安装教程 - 已隐藏 -->
          <!-- <div class="card-box">
            <span class="title">iOS 用户安装教程</span>
            <div class="cell flex align-center jus-bet">
              <div class="flex flex-column align-start">
                <span class="font-14 color-white font-bold">1.下载APP</span>
                <span class="font-14 color-gray mt-10">App下载成功后，在手机中打开设置功能，选择"通用"；</span>
              </div>
              <img src="@/assets/images/download/ios-0.png">
            </div>
            <div class="cell flex align-center jus-bet">
              <div class="flex flex-column align-start">
                <span class="font-14 color-white font-bold">2.设备管理</span>
                <span class="font-14 color-gray mt-10">在通用中，选择"VPN与设备管理"；</span>
              </div>
              <img src="@/assets/images/download/ios-1.png">
            </div>
            <div class="cell flex align-center jus-bet">
              <div class="flex flex-column align-start">
                <span class="font-14 color-white font-bold">3.选择安装</span>
                <span
                    class="font-14 color-gray mt-10">在"VPN与设备管理"中的企业级应用分类中，选择要安装的企业应用的文件名称（与打开时的提示一致），点击进入；</span>
              </div>
              <img src="@/assets/images/download/ios-2.png">
            </div>
            <div class="cell flex align-center jus-bet">
              <div class="flex flex-column align-start">
                <span class="font-14 color-white font-bold">4.设置信任</span>
                <span
                    class="font-14 color-gray mt-10">进入企业签名页面后，确认企业签名中的公司名称与应用名称后，点击"信任"；</span>
              </div>
              <img src="@/assets/images/download/ios-3.png">
            </div>
            <div class="cell flex align-center jus-bet">
              <div class="flex flex-column align-start">
                <span class="font-14 color-white font-bold">5.启动APP</span>
                <span class="font-14 color-gray mt-10">返回桌面，重新打开应用即可使用。</span>
              </div>
              <img src="@/assets/images/download/ios-4.png">
            </div>
          </div> -->
          
          <!-- Android用户安装教程 - 已隐藏 -->
          <!-- <div class="card-box">
            <span class="title">Android用户安装教程</span>
            <div class="cell flex align-center jus-bet">
              <div class="flex flex-column align-start">
                <span class="font-14 color-white font-bold">问题一：手机自带浏览器做出风险提示，不能正常下载。</span>
                <span class="font-14 color-gray mt-10">解决方法：使用Google Chrome浏览器下载安装。</span>
              </div>
              <img src="@/assets/images/download/android-0.png">
            </div>
            <div class="cell flex align-center jus-bet">
              <div class="flex flex-column align-start">
                <span class="font-14 color-white font-bold">1.安装Google Chrome浏览器。</span>
                <span
                    class="font-14 color-gray mt-10">用手机自带浏览器搜索Google Chrome浏览器，点击官方资源下载，下载完成后安装。</span>
              </div>
              <img src="@/assets/images/download/android-1.png">
            </div>
            <div class="cell flex align-center jus-bet">
              <div class="flex flex-column align-start">
                <span class="font-14 color-white font-bold">2.打开Google Chrome浏览器访问DBG官网：</span>
                <span
                    class="font-14 color-blue mt-10 pointer">https://www.bbtrade.net/</span>
              </div>
              <img src="@/assets/images/download/android-2.png">
            </div>
            <div class="cell flex align-center jus-bet">
              <div class="flex flex-column align-start">
                <span class="font-14 color-white font-bold">3.进入DBG主页，点击【下载】按钮进行下载。</span>
              </div>
              <img src="@/assets/images/download/android-3.png">
            </div>
            <div class="cell flex align-center jus-bet">
              <div class="flex flex-column align-start">
                <span class="font-14 color-white font-bold">4.点击谷歌右上角的设置按钮查看历史下载内容。</span>
              </div>
              <img src="@/assets/images/download/android-4.png">
            </div>
            <div class="cell flex align-center jus-bet">
              <div class="flex flex-column align-start">
                <span class="font-14 color-white font-bold">5.在"下载内容"里，找到安装包并点击安装。</span>
              </div>
              <img src="@/assets/images/download/android-5.png">
            </div>
            <div class="cell flex align-center jus-bet">
              <div class="flex flex-column align-start">
                <span class="font-14 color-white font-bold">问题二：在安装过程中显示"发现恶意应用"或"安全提醒"。</span>

                <span
                    class="font-14 color-gray mt-10">解决方法：下载安装包后请关闭网络进行安装，安装完成后开启网络即可正常使用。</span>
              </div>
              <img src="@/assets/images/download/android-6.png">
            </div>
          </div> -->
        </div>
      </div>
    </a-layout-content>
    <a-layout-footer>
      <Footer></Footer>
    </a-layout-footer>
  </a-layout>
</template>
<script>
import PageNav from "@/components/PageNav/PageNav.vue";
import Footer from "@/components/Footer/footer.vue";
import commonApi from "@/common/api/common.js";

export default {
  components: {Footer, PageNav},
  computed: {
    // iOS下载按钮文本 - 确保翻译正确显示
    iosDownloadText() {
      return this.$t('personal.ios_download');
    }
  },
  data() {
    return {
      config: {
        dpage: require('@/assets/qrcode.png'),
        ios_url: 'https://example.com/ios'
      },
      proGroup: [],
      isActive: 0
    }
  },
  mounted() {
    this.getConfig();
    this.updateProGroup();
  },
  watch: {
    '$i18n.locale': {
      handler() {
        this.updateProGroup();
      },
      immediate: true
    }
  },
  methods: {
    updateProGroup() {
      console.log('🌐 更新应用下载页面功能特性翻译...');
      console.log('当前语言:', this.$i18n?.locale);
      
      this.proGroup = [{
        title: this.getFeatureTitle('feature1'),
        context: this.getFeatureContext('feature1'),
        imgSrc: require('@/assets/images/product.png')
      }, {
        title: this.getFeatureTitle('feature2'),
        context: this.getFeatureContext('feature2'),
        imgSrc: require('@/assets/images/product5.png')
      }, {
        title: this.getFeatureTitle('feature3'),
        context: this.getFeatureContext('feature3'),
        imgSrc: require('@/assets/images/product6.png')
      }, {
        title: this.getFeatureTitle('feature4'),
        context: this.getFeatureContext('feature4'),
        imgSrc: require('@/assets/images/product7.png')
      }];
      
      console.log('✅ 功能特性数据更新完成:', this.proGroup.map(item => ({title: item.title, context: item.context.substring(0, 50) + '...'})));
    },
    
    getFeatureTitle(featureKey) {
      if (featureKey === 'feature1') return this.$t('app_download.lightning_trading.title');
      if (featureKey === 'feature2') return this.$t('app_download.asset_transfer.title');
      if (featureKey === 'feature3') return this.$t('app_download.trading_panel.title');
      return this.$t('app_download.account_management.title');
    },
    
    getFeatureContext(featureKey) {
      if (featureKey === 'feature1') return this.$t('app_download.lightning_trading.description');
      if (featureKey === 'feature2') return this.$t('app_download.asset_transfer.description');
      if (featureKey === 'feature3') return this.$t('app_download.trading_panel.description');
      return this.$t('app_download.account_management.description');
    },
    
    // 功能特性标题备用翻译
    getFeatureTitleFallback(featureKey) {
      const lang = this.$util.getCache('lang', 'en-US');
      const translations = {
        feature1: {
          'zh_CN': '闪电交易性能',
          'zh_Hant': '閃電交易性能',
          'en-US': 'Lightning Trading Performance',
          'ja': '高速取引パフォーマンス',
          'ko': '고속 거래 성능',
          'ru': 'Быстрая торговля',
          'th': 'ประสิทธิภาพการเทรดแบบฟ้าผ่า',
          'gm': 'Blitzschnelle Handelsleistung',
          'au': 'Lightning Trading Performance'
        },
        feature2: {
          'zh_CN': '便捷资产划转',
          'zh_Hant': '便捷資產劃轉',
          'en-US': 'Easy Asset Transfer',
          'ja': '簡単な資産移動',
          'ko': '간편한 자산 이체',
          'ru': 'Легкий перевод активов',
          'th': 'การโอนสินทรัพย์ง่ายๆ',
          'gm': 'Einfacher Vermögenstransfer',
          'au': 'Easy Asset Transfer'
        },
        feature3: {
          'zh_CN': '可定制交易面板',
          'zh_Hant': '可定製交易面板',
          'en-US': 'Customizable Trading Panel',
          'ja': 'カスタマイズ可能な取引パネル',
          'ko': '사용자 정의 가능한 거래 패널',
          'ru': 'Настраиваемая торговая панель',
          'th': 'แผงการเทรดที่ปรับแต่งได้',
          'gm': 'Anpassbares Handelsfenster',
          'au': 'Customizable Trading Panel'
        },
        feature4: {
          'zh_CN': '一体化账户管理',
          'zh_Hant': '一體化賬戶管理',
          'en-US': 'Integrated Account Management',
          'ja': '統合アカウント管理',
          'ko': '통합 계정 관리',
          'ru': 'Интегрированное управление аккаунтами',
          'th': 'การจัดการบัญชีแบบรวม',
          'gm': 'Integrierte Kontoverwaltung',
          'au': 'Integrated Account Management'
        }
      };
      
      return translations[featureKey]?.[lang] || translations[featureKey]?.['en-US'] || 'Feature';
    },
    
    // 功能特性描述备用翻译
    getFeatureContextFallback(featureKey) {
      const lang = this.$util.getCache('lang', 'en-US');
      const translations = {
        feature1: {
          'zh_CN': '提供多样化交易类型选择，订单瞬间撮合，一键闪兑，让买卖更便捷',
          'zh_Hant': '提供多樣化交易類型選擇，訂單瞬間撮合，一鍵閃兌，讓買賣更便捷',
          'en-US': 'Provides diverse trading type options, instant order matching, one-click flash exchange, making buying and selling more convenient',
          'ja': '多様な取引タイプのオプションを提供し、瞬時の注文マッチング、ワンクリック高速交換で売買をより便利にします',
          'ko': '다양한 거래 유형 옵션을 제공하며, 즉시 주문 매칭, 일회성 플래시 교환으로 매수와 매도를 더욱 편리하게 만듭니다',
          'ru': 'Предоставляет разнообразные типы торгов, мгновенное сопоставление ордеров, мгновенный обмен в один клик, что делает покупку и продажу более удобными',
          'th': 'ให้ตัวเลือกประเภทการเทรดที่หลากหลาย การจับคู่ออเดอร์ทันที การแลกเปลี่ยนแบบฟ้าผ่าด้วยคลิกเดียว ทำให้การซื้อและขายสะดวกขึ้น',
          'gm': 'Bietet diverse Handelsoptionen, sofortige Auftragszuordnung, Ein-Klick-Blitzwechsel und macht Kaufen und Verkaufen bequemer',
          'au': 'Provides diverse trading type options, instant order matching, one-click flash exchange, making buying and selling more convenient'
        },
        feature2: {
          'zh_CN': '账户内轻松划转资产，数字资产实时总览，增强币种占比饼图',
          'zh_Hant': '賬戶內輕鬆劃轉資產，數字資產實時總覽，增強幣種佔比餅圖',
          'en-US': 'Easily transfer assets within accounts, real-time digital asset overview, enhanced currency proportion pie chart',
          'ja': 'アカウント内で簡単に資産移動、リアルタイムデジタル資産概要、強化された通貨比率円グラフ',
          'ko': '계정 내에서 쉽게 자산을 이체할 수 있으며, 실시간 디지털 자산 개요, 강화된 통화 비율 파이 차트',
          'ru': 'Легко переводите активы между счетами, обзор цифровых активов в реальном времени, улучшенная круговая диаграмма пропорций валют',
          'th': 'โอนสินทรัพย์ภายในบัญชีได้อย่างง่ายดาย ภาพรวมสินทรัพย์ดิจิทัลแบบเรียลไทม์ แผนภูมิวงกลมสัดส่วนสกุลเงินที่ปรับปรุงแล้ว',
          'gm': 'Einfacher Vermögenstransfer zwischen Konten, Echtzeit-Übersicht digitaler Vermögenswerte, verbesserte Währungsanteil-Kreisdiagramm',
          'au': 'Easily transfer assets within accounts, real-time digital asset overview, enhanced currency proportion pie chart'
        },
        feature3: {
          'zh_CN': '根据不同交易习惯自由定义交易布局，增强K线和深度图表访问',
          'zh_Hant': '根據不同交易習慣自由定義交易佈局，增強K線和深度圖表訪問',
          'en-US': 'Freely define trading layout according to different trading habits, enhanced K-line and depth chart access',
          'ja': '異なる取引習慣に応じて取引レイアウトを自由に定義、強化されたKラインと深度チャートアクセス',
          'ko': '다양한 거래 습관에 따라 거래 레이아웃을 자유롭게 정의하고, 강화된 K-라인 및 깊이 차트 액세스',
          'ru': 'Свободно определяйте торговую компоновку в соответствии с различными торговыми привычками, улучшенный доступ к графикам K и глубинным графикам',
          'th': 'กำหนดเลย์เอาต์การเทรดได้อย่างอิสระตามนิสัยการเทรดที่แตกต่างกัน การเข้าถึงแผนภูมิ K-line และแผนภูมิความลึกที่ปรับปรุงแล้ว',
          'gm': 'Freie Definition der Handelslayout nach verschiedenen Handelsgewohnheiten, verbesserter Zugriff auf K-Linie und Tiefenchart',
          'au': 'Freely define trading layout according to different trading habits, enhanced K-line and depth chart access'
        },
        feature4: {
          'zh_CN': '多重安全验证设置，一个账户管理法币和数字货币账户',
          'zh_Hant': '多重安全驗證設置，一個賬戶管理法幣和數字貨幣賬戶',
          'en-US': 'Multiple security verification settings, one account manages fiat and crypto accounts',
          'ja': '複数のセキュリティ検証設定、1つのアカウントで法定通貨と暗号通貨アカウントを管理',
          'ko': '여러 보안 인증 설정, 하나의 계정으로 법정화폐 및 암호화폐 계정 관리',
          'ru': 'Множественные настройки проверки безопасности, один аккаунт управляет фиатными и криптовалютными счетами',
          'th': 'การตั้งค่าการยืนยันความปลอดภัยหลายระดับ บัญชีเดียวจัดการบัญชีเงินตราและสกุลเงินดิจิทัล',
          'gm': 'Mehrfache Sicherheitsverifizierungseinstellungen, ein Konto verwaltet Fiat- und Krypto-Konten',
          'au': 'Multiple security verification settings, one account manages fiat and crypto accounts'
        }
      };
      
      return translations[featureKey]?.[lang] || translations[featureKey]?.['en-US'] || 'Feature description';
    },
    
    // 功能特性描述备用翻译
    getFeatureContextFallback(featureKey) {
      const lang = this.$util.getCache('lang', 'en-US');
      const translations = {
        feature1: {
          'zh_CN': '提供多样化交易类型选择，订单瞬间撮合，一键闪兑，让买卖更便捷',
          'zh_Hant': '提供多樣化交易類型選擇，訂單瞬間撮合，一鍵閃兌，讓買賣更便捷',
          'en-US': 'Provides diverse trading type options, instant order matching, one-click flash exchange, making buying and selling more convenient',
          'ja': '多様な取引タイプのオプションを提供し、瞬時の注文マッチング、ワンクリック高速交換で売買をより便利にします',
          'ko': '다양한 거래 유형 옵션을 제공하며, 즉시 주문 매칭, 일회성 플래시 교환으로 매수와 매도를 더욱 편리하게 만듭니다',
          'ru': 'Предоставляет разнообразные типы торгов, мгновенное сопоставление ордеров, мгновенный обмен в один клик, что делает покупку и продажу более удобными',
          'th': 'ให้ตัวเลือกประเภทการเทรดที่หลากหลาย การจับคู่ออเดอร์ทันที การแลกเปลี่ยนแบบฟ้าผ่าด้วยคลิกเดียว ทำให้การซื้อและขายสะดวกขึ้น',
          'gm': 'Bietet diverse Handelsoptionen, sofortige Auftragszuordnung, Ein-Klick-Blitzwechsel und macht Kaufen und Verkaufen bequemer',
          'au': 'Provides diverse trading type options, instant order matching, one-click flash exchange, making buying and selling more convenient'
        },
        feature2: {
          'zh_CN': '账户内轻松划转资产，数字资产实时总览，增强币种占比饼图',
          'zh_Hant': '賬戶內輕鬆劃轉資產，數字資產實時總覽，增強幣種佔比餅圖',
          'en-US': 'Easily transfer assets within accounts, real-time digital asset overview, enhanced currency proportion pie chart',
          'ja': 'アカウント内で簡単に資産移動、リアルタイムデジタル資産概要、強化された通貨比率円グラフ',
          'ko': '계정 내에서 쉽게 자산을 이체할 수 있으며, 실시간 디지털 자산 개요, 강화된 통화 비율 파이 차트',
          'ru': 'Легко переводите активы между счетами, обзор цифровых активов в реальном времени, улучшенная круговая диаграмма пропорций валют',
          'th': 'โอนสินทรัพย์ภายในบัญชีได้อย่างง่ายดาย ภาพรวมสินทรัพย์ดิจิทัลแบบเรียลไทม์ แผนภูมิวงกลมสัดส่วนสกุลเงินที่ปรับปรุงแล้ว',
          'gm': 'Einfacher Vermögenstransfer zwischen Konten, Echtzeit-Übersicht digitaler Vermögenswerte, verbesserte Währungsanteil-Kreisdiagramm',
          'au': 'Easily transfer assets within accounts, real-time digital asset overview, enhanced currency proportion pie chart'
        },
        feature3: {
          'zh_CN': '根据不同交易习惯自由定义交易布局，增强K线和深度图表访问',
          'zh_Hant': '根據不同交易習慣自由定義交易佈局，增強K線和深度圖表訪問',
          'en-US': 'Freely define trading layout according to different trading habits, enhanced K-line and depth chart access',
          'ja': '異なる取引習慣に応じて取引レイアウトを自由に定義、強化されたKラインと深度チャートアクセス',
          'ko': '다양한 거래 습관에 따라 거래 레이아웃을 자유롭게 정의하고, 강화된 K-라인 및 깊이 차트 액세스',
          'ru': 'Свободно определяйте торговую компоновку в соответствии с различными торговыми привычками, улучшенный доступ к графикам K и глубинным графикам',
          'th': 'กำหนดเลย์เอาต์การเทรดได้อย่างอิสระตามนิสัยการเทรดที่แตกต่างกัน การเข้าถึงแผนภูมิ K-line และแผนภูมิความลึกที่ปรับปรุงแล้ว',
          'gm': 'Freie Definition der Handelslayout nach verschiedenen Handelsgewohnheiten, verbesserter Zugriff auf K-Linie und Tiefenchart',
          'au': 'Freely define trading layout according to different trading habits, enhanced K-line and depth chart access'
        },
        feature4: {
          'zh_CN': '多重安全验证设置，一个账户管理法币和数字货币账户',
          'zh_Hant': '多重安全驗證設置，一個賬戶管理法幣和數字貨幣賬戶',
          'en-US': 'Multiple security verification settings, one account manages fiat and crypto accounts',
          'ja': '複数のセキュリティ検証設定、1つのアカウントで法定通貨と暗号通貨アカウントを管理',
          'ko': '여러 보안 인증 설정, 하나의 계정으로 법정화폐 및 암호화폐 계정 관리',
          'ru': 'Множественные настройки проверки безопасности, один аккаунт управляет фиатными и криптовалютными счетами',
          'th': 'การตั้งค่าการยืนยันความปลอดภัยหลายระดับ บัญชีเดียวจัดการบัญชีเงินตราและสกุลเงินดิจิทัล',
          'gm': 'Mehrfache Sicherheitsverifizierungseinstellungen, ein Konto verwaltet Fiat- und Krypto-Konten',
          'au': 'Multiple security verification settings, one account manages fiat and crypto accounts'
        }
      };
      
      return translations[featureKey]?.[lang] || translations[featureKey]?.['en-US'] || 'Feature description';
    },
    
    // 获取iOS下载文本的备用方案
    getIOSDownloadTextFallback() {
      const lang = this.$util.getCache('lang', 'en-US');
      const translations = {
        'zh_CN': 'iOS下载',
        'zh_Hant': 'iOS下載',
        'en-US': 'iOS Download',
        'ja': 'iOSダウンロード',
        'ko': 'iOS 다운로드',
        'ru': 'Скачать для iOS',
        'th': 'ดาวน์โหลดสำหรับ iOS',
        'gm': 'iOS-Download',
        'au': 'iOS Download'
      };
      
      return translations[lang] || translations['en-US'];
    },
    
    getConfig() {
      console.log('🔧 开始获取手机端下载配置...');
      commonApi.config(1).then(res => {
        console.log('✅ 配置API响应:', res);
        console.log('📊 配置数据结构:', JSON.stringify(res.data, null, 2));
        if (res.code === 200 && res.data) {
          // 直接使用接口返回的数据，不进行本地映射
          this.config = res.data;
          console.log('✅ 下载配置设置成功:', this.config);
          console.log('🔍 检查下载相关字段:');
          console.log('  - ios_url:', this.config['ios_url']);
          console.log('  - download:', this.config['download']);
          console.log('  - dpage:', this.config['dpage']);
          console.log('  - 所有字段:', Object.keys(this.config));
          
          // 验证iOS下载链接字段
          if (!this.config['ios_url'] || this.config['ios_url'] === '') {
            console.log('⚠️ ios_url字段不存在或为空，设置默认值');
            this.config['ios_url'] = '#';
          }
          if (!this.config['dpage'] || this.config['dpage'] === '') {
            console.log('⚠️ dpage字段不存在或为空，设置默认值');
            this.config['dpage'] = require('@/assets/qrcode.png');
          }
        } else {
          console.log('⚠️ 使用默认配置');
          this.config = {
            dpage: require('@/assets/qrcode.png'),
            ios_url: '#'
          };
        }
      }).catch(error => {
        console.error('❌ 配置API调用失败:', error);
        console.log('⚠️ 使用默认配置');
        this.config = {
          dpage: require('@/assets/qrcode.png'),
          ios_url: '#',
          download: '#'
        };
      });
    },
    mouseEnter(index) {
      console.log(index);
      this.isActive = index;
    },
    downloadIOS() {
      console.log('📱 点击iOS下载按钮');
      console.log('iOS URL:', this.config['ios_url']);
      
      // 检查iOS下载链接是否有效
      if (!this.config['ios_url'] || this.config['ios_url'] === '#' || this.config['ios_url'] === '') {
        // 显示未配置提示
        this.$notification.warning({
          content: this.getIOSNotConfiguredMessage(),
          duration: 3000
        });
        return;
      }
      
      try {
        // 打开iOS下载链接
        window.open(this.config['ios_url'], '_blank');
        
        // 显示下载提示
        this.$notification.success({
          content: this.getIOSDownloadMessage(),
          duration: 2000
        });
      } catch (error) {
        console.error('❌ iOS下载失败:', error);
        this.$notification.error({
          content: this.getIOSDownloadErrorMessage(),
          duration: 3000
        });
      }
    },
    
    // 获取iOS下载提示信息（多语言）
    getIOSDownloadMessage() {
      const lang = this.$util.getCache('lang', 'en-US');
      const messages = {
        'zh_CN': '正在跳转到App Store...',
        'zh_Hant': '正在跳轉到App Store...',
        'en-US': 'Redirecting to App Store...',
        'ja': 'App Storeにリダイレクトしています...',
        'ko': 'App Store로 이동 중...',
        'ru': 'Перенаправление в App Store...',
        'th': 'กำลังเปลี่ยนเส้นทางไปยัง App Store...',
        'gm': 'Weiterleitung zum App Store...',
        'au': 'Redirecting to App Store...'
      };
      
      return messages[lang] || messages['en-US'];
    },
    
    // 获取iOS未配置提示信息（多语言）
    getIOSNotConfiguredMessage() {
      const lang = this.$util.getCache('lang', 'en-US');
      const messages = {
        'zh_CN': 'iOS应用下载链接暂未配置，请联系客服',
        'zh_Hant': 'iOS應用下載鏈接暫未配置，請聯繫客服',
        'en-US': 'iOS app download link not configured, please contact customer service',
        'ja': 'iOSアプリのダウンロードリンクが設定されていません。カスタマーサービスにお問い合わせください',
        'ko': 'iOS 앱 다운로드 링크가 구성되지 않았습니다. 고객 서비스에 문의해주세요',
        'ru': 'Ссылка для скачивания iOS-приложения не настроена, обратитесь в службу поддержки',
        'th': 'ลิงก์ดาวน์โหลดแอป iOS ไม่ได้กำหนดค่า กรุณาติดต่อฝ่ายบริการลูกค้า',
        'gm': 'iOS-App-Download-Link nicht konfiguriert, wenden Sie sich an den Kundendienst',
        'au': 'iOS app download link not configured, please contact customer service'
      };
      
      return messages[lang] || messages['en-US'];
    },
    
    // 获取iOS下载错误信息（多语言）
    getIOSDownloadErrorMessage() {
      const lang = this.$util.getCache('lang', 'en-US');
      const messages = {
        'zh_CN': 'iOS下载失败，请稍后重试',
        'zh_Hant': 'iOS下載失敗，請稍後重試',
        'en-US': 'iOS download failed, please try again later',
        'ja': 'iOSダウンロードに失敗しました。後でもう一度お試しください',
        'ko': 'iOS 다운로드에 실패했습니다. 나중에 다시 시도해주세요',
        'ru': 'Ошибка скачивания iOS, попробуйте позже',
        'th': 'การดาวน์โหลด iOS ล้มเหลว กรุณาลองอีกครั้งในภายหลัง',
        'gm': 'iOS-Download fehlgeschlagen, bitte versuchen Sie es später erneut',
        'au': 'iOS download failed, please try again later'
      };
      
      return messages[lang] || messages['en-US'];
    }
  }
}
</script>
<style lang="scss" scoped>
@import "./appDownload.scss";
</style>
